import styled from 'styled-components';
import { saasModernTheme } from 'common/theme/saasModern';

export const FooterWrapper = styled.footer`
  position: relative;
  background: var(--Background-Default, #111927);
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
  padding: ${saasModernTheme.space[8]}px ${saasModernTheme.space[4]}px;
`;

export const FooterContainer = styled.div`
  display: flex;
  width: 70%;
  justify-content: space-between;
  @media (max-width: 1410px) {
    width: 65%;
  }
  @media (max-width: 800px) {
    display: flex;
    flex-direction: column;
  }
`;

export const List = styled.ul`
  margin: 0;
  padding: 0;
  list-style-type: none;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const ListItem = styled.li`
  margin-bottom: 8px;

  a {
    text-decoration: none;
    transition: color 0.2s ease;
    color: var(--Text-Secondary, #636f81);
    font-family: ${saasModernTheme.fontFamily};
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 28px;
    &:hover {
      color: ${saasModernTheme.defaultBackgroundColor};
    }
  }
`;

export const TitleInfo = styled.h3`
  font-weight: bold;
  margin-bottom: ${saasModernTheme.space[4]}px;
  color: #fff;
  font-family: ${saasModernTheme.fontFamily};
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px;
`;

export const ContentSocialMedia = styled.div`
  display: flex;
  justify-content: center;
  gap: 16px;
  margin-top: ${saasModernTheme.space[2]}px;
`;

export const Description = styled.p`
  max-width: 269px;
  margin: ${saasModernTheme.space[4]}px 0;
  color: var(--Text-Secondary, #636f81);
  text-align: justify;
  font-family: ${saasModernTheme.fontFamily};
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
`;

export const Box = styled.div``;

export const BottomFooter = styled.div`
  margin-top: ${saasModernTheme.space[8]}px;
  padding-top: ${saasModernTheme.space[4]}px;
  border-top: 1px solid #333;
  width: 70%;
  text-align: center;
  @media (max-width: 1410px) {
    width: 65%;
  }
`;

export const BottomFooterText = styled.p`
  color: var(--Text-Secondary, #919bab);
  text-align: center;
  font-family: ${saasModernTheme.fontFamily};
  font-size: 12px;
  font-style: normal;
  font-weight: 300;
  line-height: 18px;
`;

export const BottomFooterTCopyright = styled.p`
  color: var(--Text-Secondary, #919bab);
  text-align: center;
  font-family: ${saasModernTheme.fontFamily};
  font-size: 12px;
  font-style: normal;
  font-weight: 300;
  line-height: 18px;
  margin-top: 30px;
`;

export const BottomFooterLink = styled.a.attrs({
  target: '_blank',
  rel: 'noopener noreferrer',
})`
  text-decoration: none;
  margin-bottom: 100px;
  transition: color 0.2s ease;
  color: var(--Text-Secondary, #636f81);
  font-family: ${saasModernTheme.fontFamily};
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;

  &:hover {
    color: ${saasModernTheme.defaultBackgroundColor};
  }
`;

export const BottomFooterSeparator = styled.span`
  color: #b6b6b6;
  margin: 0 ${saasModernTheme.space[2]}px;
`;

export const ScrollTopButtonWrapper = styled.div`
  position: absolute;
  bottom: 60px;
  right: 260px;
  @media (max-width: 768px) {
    left: 20px;
    bottom: 30px;
  }
`;

export const ScrollTopButton = styled.button`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: white;
  border: none;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: background-color 0.3s ease;

  &:hover {
    box-shadow: ${saasModernTheme.gradiantShadow};
  }

  svg {
    width: 20px;
    height: 20px;
    fill: #333;
  }
`;

export const LogoContainer = styled(Box)`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--grey-transparent-8, rgba(145, 155, 171, 0.08));
  &:hover {
    background: ${saasModernTheme.defaultBackgroundColor};
    svg {
      path {
        fill: white;
      }
    }
  }
`;
